export const bookCategories = [
  { id: "gaokao", label: "高考备考", icon: "ri-book-open-line", color: "bg-red-50 text-red-600", count: 128 },
  { id: "postgrad", label: "研究生考试", icon: "ri-graduation-cap-line", color: "bg-orange-50 text-orange-600", count: 96 },
  { id: "accounting", label: "会计考试", icon: "ri-calculator-line", color: "bg-yellow-50 text-yellow-600", count: 74 },
  { id: "english", label: "英语考试", icon: "ri-translate-2", color: "bg-green-50 text-green-600", count: 112 },
  { id: "gratitude", label: "感恩教育", icon: "ri-heart-line", color: "bg-pink-50 text-pink-600", count: 58 },
  { id: "happiness", label: "幸福开心", icon: "ri-sun-line", color: "bg-amber-50 text-amber-600", count: 43 },
  { id: "children", label: "儿童成长", icon: "ri-seedling-line", color: "bg-emerald-50 text-emerald-600", count: 87 },
  { id: "gift", label: "节日礼物书", icon: "ri-gift-line", color: "bg-rose-50 text-rose-600", count: 65 },
];

export const featuredBooks = [
  // ── 高考备考 ×5 ──────────────────────────────────────────────
  {
    id: "b001",
    title: "2026高考数学满分冲刺",
    subtitle: "全国卷专项突破·真题精析",
    category: "gaokao",
    categoryLabel: "高考备考",
    author: "李明远 主编",
    publisher: "清华大学出版社",
    price: 68,
    originalPrice: 98,
    rating: 4.9,
    reviews: 3842,
    sold: 12680,
    image: "https://public.readdy.ai/ai/img_res/0a37e44a9fdba21c42169d2be2a9d4f6.jpg",
    tags: ["高考必备", "真题解析", "满分技巧"],
    supplierName: "清华教育出版社",
    supplierVerified: true,
    description: "涵盖全国卷I/II/III所有考点，配套1000道精选真题，附赠在线视频讲解，帮助考生系统掌握高考数学核心知识点，冲刺满分。",
    commissionRate: 12,
  },
  {
    id: "b009",
    title: "高考语文作文满分宝典",
    subtitle: "素材积累·写作技巧·范文精选",
    category: "gaokao",
    categoryLabel: "高考备考",
    author: "刘语文 主编",
    publisher: "人民教育出版社",
    price: 52,
    originalPrice: 72,
    rating: 4.8,
    reviews: 4123,
    sold: 16780,
    image: "https://readdy.ai/api/search-image?query=Chinese%20high%20school%20Chinese%20language%20composition%20exam%20book%20cover%2C%20elegant%20design%20with%20red%20and%20white%20colors%2C%20Chinese%20calligraphy%20brush%20strokes%20and%20writing%20symbols%2C%20premium%20educational%20book%2C%20clean%20sophisticated%20design%20on%20white%20background&width=300&height=400&seq=book009&orientation=portrait",
    tags: ["高考作文", "满分技巧", "素材积累"],
    supplierName: "人教版教育书局",
    supplierVerified: true,
    description: "精选近10年高考满分作文，深度解析写作技巧，提供丰富素材积累，帮助考生掌握高考语文作文的核心方法，轻松拿满分。",
    commissionRate: 11,
  },
  {
    id: "b013",
    title: "高考物理压轴题全解",
    subtitle: "力学·电磁·光学·近代物理",
    category: "gaokao",
    categoryLabel: "高考备考",
    author: "陈物理 主编",
    publisher: "复旦大学出版社",
    price: 62,
    originalPrice: 88,
    rating: 4.8,
    reviews: 2987,
    sold: 11200,
    image: "https://readdy.ai/api/search-image?query=Chinese%20high%20school%20physics%20exam%20book%20cover%2C%20dark%20navy%20blue%20background%20with%20glowing%20circuit%20diagrams%20and%20physics%20formulas%2C%20electric%20sparks%20and%20atomic%20orbit%20illustrations%2C%20premium%20science%20textbook%20design%2C%20bold%20modern%20typography%2C%20professional%20educational%20book&width=300&height=400&seq=book013&orientation=portrait",
    tags: ["高考物理", "压轴题", "全题型"],
    supplierName: "复旦教育出版社",
    supplierVerified: true,
    description: "专攻高考物理压轴题，涵盖力学、电磁学、光学、近代物理全部题型，每题配有详细解题思路和多种解法，帮助考生突破物理难关。",
    commissionRate: 12,
  },
  {
    id: "b014",
    title: "高考化学实验专项突破",
    subtitle: "实验设计·操作要点·答题规范",
    category: "gaokao",
    categoryLabel: "高考备考",
    author: "周化学 著",
    publisher: "南京大学出版社",
    price: 58,
    originalPrice: 82,
    rating: 4.7,
    reviews: 2341,
    sold: 9870,
    image: "https://readdy.ai/api/search-image?query=Chinese%20high%20school%20chemistry%20exam%20book%20cover%2C%20vibrant%20green%20and%20white%20design%20with%20laboratory%20flask%20and%20chemical%20reaction%20illustrations%2C%20colorful%20molecular%20structures%2C%20science%20experiment%20themed%20educational%20book%2C%20clean%20bright%20modern%20layout%20on%20white%20background&width=300&height=400&seq=book014&orientation=portrait",
    tags: ["高考化学", "实验专项", "答题规范"],
    supplierName: "南大教育出版",
    supplierVerified: true,
    description: "专项突破高考化学实验题，系统讲解实验设计原理、操作注意事项和标准答题规范，配套50个经典实验详解，让化学实验不再失分。",
    commissionRate: 11,
  },
  {
    id: "b015",
    title: "高考英语阅读理解200篇",
    subtitle: "题型分类·解题技巧·词汇积累",
    category: "gaokao",
    categoryLabel: "高考备考",
    author: "吴英语 编著",
    publisher: "外语教学与研究出版社",
    price: 55,
    originalPrice: 76,
    rating: 4.9,
    reviews: 5102,
    sold: 21300,
    image: "https://readdy.ai/api/search-image?query=Chinese%20high%20school%20English%20reading%20comprehension%20exam%20book%20cover%2C%20elegant%20cream%20and%20burgundy%20design%20with%20open%20book%20and%20English%20text%20passages%2C%20world%20map%20background%2C%20sophisticated%20language%20learning%20book%2C%20refined%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book015&orientation=portrait",
    tags: ["高考英语", "阅读理解", "解题技巧"],
    supplierName: "外研社教育",
    supplierVerified: true,
    description: "精选200篇高考英语阅读理解真题及模拟题，按题型分类讲解，总结解题技巧，同步积累高频词汇，全面提升英语阅读能力。",
    commissionRate: 13,
  },
  // ── 研究生考试 ×5 ──────────────────────────────────────────────
  {
    id: "b002",
    title: "考研英语词汇5500",
    subtitle: "词根词缀记忆法·场景例句",
    category: "postgrad",
    categoryLabel: "研究生考试",
    author: "王晓燕 著",
    publisher: "北京大学出版社",
    price: 45,
    originalPrice: 65,
    rating: 4.8,
    reviews: 5621,
    sold: 28900,
    image: "https://readdy.ai/api/search-image?query=Chinese%20postgraduate%20entrance%20exam%20English%20vocabulary%20book%20cover%2C%20clean%20white%20background%20with%20green%20and%20gold%20design%20elements%2C%20English%20letters%20and%20Chinese%20characters%2C%20professional%20study%20book%2C%20elegant%20minimalist%20design&width=300&height=400&seq=book002&orientation=portrait",
    tags: ["考研必备", "词汇记忆", "高频词汇"],
    supplierName: "北大教育书局",
    supplierVerified: true,
    description: "精选考研英语高频词汇5500个，采用词根词缀记忆法，配合真实语境例句，让词汇记忆事半功倍，是考研英语备考的必备工具书。",
    commissionRate: 10,
  },
  {
    id: "b011",
    title: "考研政治核心考点精讲",
    subtitle: "马原·毛概·近代史·思修",
    category: "postgrad",
    categoryLabel: "研究生考试",
    author: "政治研究院 编",
    publisher: "中国人民大学出版社",
    price: 78,
    originalPrice: 108,
    rating: 4.7,
    reviews: 3456,
    sold: 14500,
    image: "https://readdy.ai/api/search-image?query=Chinese%20postgraduate%20political%20theory%20exam%20book%20cover%2C%20professional%20design%20with%20deep%20red%20and%20gold%20colors%2C%20Chinese%20national%20emblem%20style%20elements%2C%20authoritative%20academic%20book%2C%20clean%20formal%20design%20on%20white%20background&width=300&height=400&seq=book011&orientation=portrait",
    tags: ["考研政治", "核心考点", "全科覆盖"],
    supplierName: "人大教育出版集团",
    supplierVerified: true,
    description: "全面覆盖考研政治四大科目，重点考点逐一精讲，配套历年真题解析，帮助考生系统掌握考研政治知识体系，高效备考。",
    commissionRate: 13,
  },
  {
    id: "b016",
    title: "考研数学一全程复习",
    subtitle: "高数·线代·概率·真题精解",
    category: "postgrad",
    categoryLabel: "研究生考试",
    author: "张数学 主编",
    publisher: "清华大学出版社",
    price: 98,
    originalPrice: 138,
    rating: 4.9,
    reviews: 6234,
    sold: 31500,
    image: "https://readdy.ai/api/search-image?query=Chinese%20postgraduate%20math%20exam%20comprehensive%20review%20book%20cover%2C%20deep%20blue%20and%20silver%20design%20with%20complex%20mathematical%20equations%20and%20calculus%20formulas%2C%20geometric%20patterns%2C%20authoritative%20academic%20textbook%2C%20sophisticated%20clean%20layout%20on%20white%20background&width=300&height=400&seq=book016&orientation=portrait",
    tags: ["考研数学", "全程复习", "真题精解"],
    supplierName: "清华教育出版社",
    supplierVerified: true,
    description: "考研数学一全程复习教材，涵盖高等数学、线性代数、概率论全部考点，配套近20年真题精解，是考研数学备考的权威参考书。",
    commissionRate: 14,
  },
  {
    id: "b017",
    title: "考研专业课·计算机408",
    subtitle: "数据结构·操作系统·计算机网络·组成原理",
    category: "postgrad",
    categoryLabel: "研究生考试",
    author: "王计算机 编",
    publisher: "电子工业出版社",
    price: 118,
    originalPrice: 158,
    rating: 4.8,
    reviews: 3876,
    sold: 17800,
    image: "https://readdy.ai/api/search-image?query=Chinese%20postgraduate%20computer%20science%20exam%20book%20cover%2C%20modern%20tech%20design%20with%20dark%20background%20and%20glowing%20circuit%20board%20patterns%2C%20binary%20code%20and%20network%20topology%20diagrams%2C%20professional%20IT%20academic%20book%2C%20sleek%20futuristic%20typography%20on%20clean%20background&width=300&height=400&seq=book017&orientation=portrait",
    tags: ["考研408", "计算机专业", "四科合一"],
    supplierName: "电子工业出版社",
    supplierVerified: true,
    description: "考研计算机专业课408全科复习，数据结构、操作系统、计算机网络、计算机组成原理四科合一，配套历年真题和模拟题，高效备考。",
    commissionRate: 15,
  },
  {
    id: "b018",
    title: "MBA联考综合能力全攻略",
    subtitle: "逻辑·写作·数学·英语",
    category: "postgrad",
    categoryLabel: "研究生考试",
    author: "刘MBA 著",
    publisher: "机械工业出版社",
    price: 108,
    originalPrice: 148,
    rating: 4.7,
    reviews: 2654,
    sold: 12300,
    image: "https://readdy.ai/api/search-image?query=Chinese%20MBA%20entrance%20exam%20book%20cover%2C%20professional%20business%20design%20with%20gold%20and%20charcoal%20colors%2C%20business%20chart%20and%20briefcase%20illustrations%2C%20executive%20education%20book%2C%20premium%20corporate%20style%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book018&orientation=portrait",
    tags: ["MBA联考", "综合能力", "全科攻略"],
    supplierName: "机械工业出版社",
    supplierVerified: true,
    description: "MBA联考综合能力全面攻略，逻辑推理、写作、数学、英语四科系统讲解，配套历年真题解析和高分技巧，助力考生顺利进入顶尖商学院。",
    commissionRate: 16,
  },
  // ── 会计考试 ×4 ──────────────────────────────────────────────
  {
    id: "b003",
    title: "注册会计师CPA财务会计",
    subtitle: "2026年最新版·考点精讲",
    category: "accounting",
    categoryLabel: "会计考试",
    author: "张会计 主编",
    publisher: "中国财政经济出版社",
    price: 128,
    originalPrice: 168,
    rating: 4.7,
    reviews: 2134,
    sold: 8760,
    image: "https://readdy.ai/api/search-image?query=Chinese%20CPA%20accounting%20exam%20textbook%20cover%2C%20professional%20design%20with%20teal%20and%20gold%20colors%20on%20white%20background%2C%20financial%20charts%20and%20accounting%20symbols%2C%20authoritative%20educational%20book%20style%2C%20clean%20minimalist%20layout&width=300&height=400&seq=book003&orientation=portrait",
    tags: ["CPA必备", "财务会计", "考点精讲"],
    supplierName: "财经教育出版集团",
    supplierVerified: true,
    description: "2026年最新版CPA财务会计教材，全面覆盖考试大纲，重点难点逐一突破，配套历年真题解析，助力考生一次通过CPA考试。",
    commissionRate: 15,
  },
  {
    id: "b019",
    title: "初级会计职称考试宝典",
    subtitle: "初级会计实务·经济法基础",
    category: "accounting",
    categoryLabel: "会计考试",
    author: "赵会计 主编",
    publisher: "中国财政经济出版社",
    price: 88,
    originalPrice: 118,
    rating: 4.8,
    reviews: 4521,
    sold: 19600,
    image: "https://readdy.ai/api/search-image?query=Chinese%20junior%20accounting%20certificate%20exam%20book%20cover%2C%20clean%20professional%20design%20with%20warm%20orange%20and%20white%20colors%2C%20accounting%20ledger%20and%20calculator%20illustrations%2C%20official%20certification%20exam%20guide%2C%20authoritative%20clean%20layout%20on%20white%20background&width=300&height=400&seq=book019&orientation=portrait",
    tags: ["初级会计", "职称考试", "双科合一"],
    supplierName: "财经教育出版集团",
    supplierVerified: true,
    description: "初级会计职称考试双科合一教材，初级会计实务和经济法基础全面覆盖，配套历年真题和模拟卷，帮助考生高效备考，一次通过初级会计考试。",
    commissionRate: 14,
  },
  {
    id: "b020",
    title: "中级会计师·财务管理精讲",
    subtitle: "资金管理·投资决策·财务分析",
    category: "accounting",
    categoryLabel: "会计考试",
    author: "孙财务 著",
    publisher: "立信会计出版社",
    price: 138,
    originalPrice: 178,
    rating: 4.6,
    reviews: 1876,
    sold: 7650,
    image: "https://readdy.ai/api/search-image?query=Chinese%20intermediate%20accountant%20financial%20management%20exam%20book%20cover%2C%20sophisticated%20design%20with%20deep%20green%20and%20gold%20colors%2C%20financial%20graphs%20and%20balance%20sheet%20illustrations%2C%20premium%20professional%20accounting%20book%2C%20elegant%20clean%20typography%20on%20white%20background&width=300&height=400&seq=book020&orientation=portrait",
    tags: ["中级会计", "财务管理", "考点精讲"],
    supplierName: "立信会计出版社",
    supplierVerified: true,
    description: "中级会计师财务管理科目精讲，资金管理、投资决策、财务分析三大模块深度解析，配套历年真题和考点总结，助力考生攻克财务管理难关。",
    commissionRate: 15,
  },
  {
    id: "b033",
    title: "税务师考试全科通关",
    subtitle: "税法一·税法二·财务与会计",
    category: "accounting",
    categoryLabel: "会计考试",
    author: "税务专家团队",
    publisher: "中国税务出版社",
    price: 158,
    originalPrice: 208,
    rating: 4.7,
    reviews: 1432,
    sold: 5980,
    image: "https://readdy.ai/api/search-image?query=Chinese%20tax%20accountant%20exam%20book%20cover%2C%20authoritative%20design%20with%20dark%20red%20and%20gold%20colors%2C%20Chinese%20tax%20bureau%20emblem%20style%2C%20official%20government%20certification%20exam%20guide%2C%20formal%20professional%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book033&orientation=portrait",
    tags: ["税务师", "全科通关", "税法精讲"],
    supplierName: "中国税务出版社",
    supplierVerified: true,
    description: "税务师考试全科通关教材，税法一、税法二、财务与会计三科系统讲解，配套历年真题和模拟题，帮助考生高效备考，顺利通过税务师考试。",
    commissionRate: 16,
  },
  // ── 英语考试 ×5 ──────────────────────────────────────────────
  {
    id: "b004",
    title: "雅思IELTS 9分突破",
    subtitle: "听说读写全面提升·真题精讲",
    category: "english",
    categoryLabel: "英语考试",
    author: "陈雅思 著",
    publisher: "外语教学与研究出版社",
    price: 88,
    originalPrice: 118,
    rating: 4.9,
    reviews: 4567,
    sold: 19800,
    image: "https://readdy.ai/api/search-image?query=IELTS%20English%20exam%20preparation%20book%20cover%2C%20elegant%20design%20with%20teal%20and%20white%20colors%2C%20globe%20and%20language%20symbols%2C%20professional%20study%20guide%2C%20clean%20modern%20typography%20on%20white%20background&width=300&height=400&seq=book004&orientation=portrait",
    tags: ["雅思备考", "9分目标", "真题精讲"],
    supplierName: "外研社教育",
    supplierVerified: true,
    description: "系统讲解雅思听说读写四项技能，收录近5年真题并逐题精析，配套音频资料，帮助考生全面提升英语综合能力，冲刺雅思9分。",
    commissionRate: 12,
  },
  {
    id: "b021",
    title: "托福TOEFL 110分冲刺",
    subtitle: "阅读·听力·口语·写作全攻略",
    category: "english",
    categoryLabel: "英语考试",
    author: "林托福 著",
    publisher: "外语教学与研究出版社",
    price: 96,
    originalPrice: 128,
    rating: 4.8,
    reviews: 3421,
    sold: 14500,
    image: "https://readdy.ai/api/search-image?query=TOEFL%20exam%20preparation%20book%20cover%2C%20modern%20design%20with%20forest%20green%20and%20white%20colors%2C%20American%20university%20campus%20illustration%2C%20English%20language%20test%20guide%2C%20professional%20study%20book%20with%20clean%20typography%2C%20globe%20and%20academic%20symbols%20on%20white%20background&width=300&height=400&seq=book021&orientation=portrait",
    tags: ["托福备考", "110分目标", "四科全攻"],
    supplierName: "外研社教育",
    supplierVerified: true,
    description: "托福TOEFL全科备考指南，阅读、听力、口语、写作四项技能系统提升，收录官方真题并逐题精析，配套音频资料，冲刺110分高分。",
    commissionRate: 13,
  },
  {
    id: "b022",
    title: "四六级英语高分突破",
    subtitle: "CET-4/CET-6·真题精解·写作模板",
    category: "english",
    categoryLabel: "英语考试",
    author: "周英语 编著",
    publisher: "高等教育出版社",
    price: 48,
    originalPrice: 68,
    rating: 4.9,
    reviews: 8934,
    sold: 45600,
    image: "https://readdy.ai/api/search-image?query=Chinese%20CET-4%20CET-6%20English%20exam%20book%20cover%2C%20bright%20and%20energetic%20design%20with%20amber%20and%20white%20colors%2C%20graduation%20cap%20and%20English%20alphabet%20decorations%2C%20popular%20university%20exam%20guide%2C%20clean%20modern%20layout%20with%20bold%20typography%20on%20white%20background&width=300&height=400&seq=book022&orientation=portrait",
    tags: ["四六级", "高分突破", "写作模板"],
    supplierName: "高等教育出版社",
    supplierVerified: true,
    description: "大学英语四六级高分突破全攻略，真题精解、写作模板、听力技巧三合一，配套近10年真题解析，帮助大学生轻松通过四六级考试。",
    commissionRate: 10,
  },
  {
    id: "b023",
    title: "商务英语BEC高级全攻略",
    subtitle: "听说读写·商务场景·真题精讲",
    category: "english",
    categoryLabel: "英语考试",
    author: "陈商务 著",
    publisher: "剑桥大学出版社",
    price: 78,
    originalPrice: 108,
    rating: 4.7,
    reviews: 1987,
    sold: 8900,
    image: "https://readdy.ai/api/search-image?query=Business%20English%20BEC%20exam%20book%20cover%2C%20professional%20corporate%20design%20with%20navy%20and%20gold%20colors%2C%20business%20meeting%20and%20handshake%20illustrations%2C%20Cambridge%20English%20certification%20guide%2C%20sophisticated%20executive%20style%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book023&orientation=portrait",
    tags: ["BEC高级", "商务英语", "职场必备"],
    supplierName: "剑桥教育出版",
    supplierVerified: true,
    description: "商务英语BEC高级全攻略，涵盖商务场景听说读写四项技能，配套剑桥官方真题精讲，帮助职场人士提升商务英语能力，顺利通过BEC高级考试。",
    commissionRate: 14,
  },
  {
    id: "b034",
    title: "英语口语流利说·零基础到精通",
    subtitle: "日常对话·商务口语·发音纠正",
    category: "english",
    categoryLabel: "英语考试",
    author: "口语训练营 编",
    publisher: "外语教学与研究出版社",
    price: 58,
    originalPrice: 78,
    rating: 4.8,
    reviews: 6543,
    sold: 32100,
    image: "https://readdy.ai/api/search-image?query=English%20speaking%20fluency%20book%20cover%2C%20friendly%20and%20approachable%20design%20with%20warm%20coral%20and%20white%20colors%2C%20speech%20bubble%20and%20smiling%20face%20illustration%2C%20conversational%20English%20learning%20book%2C%20modern%20clean%20typography%20on%20white%20background&width=300&height=400&seq=book034&orientation=portrait",
    tags: ["英语口语", "零基础", "流利表达"],
    supplierName: "外研社教育",
    supplierVerified: true,
    description: "从零基础到流利口语的完整学习路径，涵盖日常对话、商务口语、发音纠正三大模块，配套真人录音和口语练习题，让英语口语突飞猛进。",
    commissionRate: 12,
  },
  // ── 感恩教育 ×4 ──────────────────────────────────────────────
  {
    id: "b005",
    title: "感恩父母·爱的教育",
    subtitle: "亲子共读·培养感恩之心",
    category: "gratitude",
    categoryLabel: "感恩教育",
    author: "林爱心 著",
    publisher: "人民教育出版社",
    price: 38,
    originalPrice: 52,
    rating: 5.0,
    reviews: 1876,
    sold: 9340,
    image: "https://readdy.ai/api/search-image?query=Chinese%20gratitude%20education%20book%20for%20children%20and%20parents%2C%20warm%20and%20loving%20design%20with%20soft%20pink%20and%20gold%20colors%2C%20illustration%20of%20family%20holding%20hands%2C%20heartwarming%20children%20book%20cover%2C%20gentle%20and%20beautiful%20design%20on%20white%20background&width=300&height=400&seq=book005&orientation=portrait",
    tags: ["感恩教育", "亲子共读", "爱的教育"],
    supplierName: "爱心教育出版社",
    supplierVerified: true,
    description: "通过温暖的故事和精美插图，引导孩子学会感恩父母、珍惜友情、回馈社会。适合3-12岁亲子共读，是培养孩子感恩之心的最佳读物。",
    commissionRate: 18,
  },
  {
    id: "b007",
    title: "关爱老人·温暖夕阳",
    subtitle: "尊老敬老·传承美德",
    category: "gratitude",
    categoryLabel: "感恩教育",
    author: "孙敬老 著",
    publisher: "老龄出版社",
    price: 42,
    originalPrice: 58,
    rating: 4.9,
    reviews: 987,
    sold: 4320,
    image: "https://readdy.ai/api/search-image?query=Chinese%20book%20about%20caring%20for%20elderly%20grandparents%2C%20warm%20and%20touching%20design%20with%20soft%20golden%20and%20warm%20colors%2C%20illustration%20of%20grandchildren%20with%20grandparents%2C%20heartwarming%20family%20values%20book%20cover%2C%20gentle%20beautiful%20design%20on%20white%20background&width=300&height=400&seq=book007&orientation=portrait",
    tags: ["尊老敬老", "传统美德", "家庭温暖"],
    supplierName: "爱心教育出版社",
    supplierVerified: true,
    description: "通过真实感人的故事，传递尊老敬老的传统美德，引导年轻人关爱身边的长者，让爱与温暖在家庭中传递，共建和谐社会。",
    commissionRate: 16,
  },
  {
    id: "b012",
    title: "感恩社会·公益心培养",
    subtitle: "志愿服务·回馈社会·共建美好",
    category: "gratitude",
    categoryLabel: "感恩教育",
    author: "公益基金会 编著",
    publisher: "社会科学文献出版社",
    price: 35,
    originalPrice: 48,
    rating: 4.9,
    reviews: 876,
    sold: 3210,
    image: "https://readdy.ai/api/search-image?query=Chinese%20social%20responsibility%20and%20gratitude%20education%20book%20cover%2C%20warm%20and%20inspiring%20design%20with%20green%20and%20gold%20colors%2C%20community%20helping%20hands%20illustration%2C%20positive%20social%20values%20book%2C%20clean%20uplifting%20design%20on%20white%20background&width=300&height=400&seq=book012&orientation=portrait",
    tags: ["感恩社会", "公益精神", "志愿服务"],
    supplierName: "公益教育出版社",
    supplierVerified: true,
    description: "通过真实的公益故事和志愿服务案例，激励读者积极参与社会公益活动，培养感恩社会、回馈社会的公益精神，共建美好家园。",
    commissionRate: 20,
  },
  {
    id: "b024",
    title: "朋友之间的感恩与珍惜",
    subtitle: "友情的力量·感恩身边的人",
    category: "gratitude",
    categoryLabel: "感恩教育",
    author: "李友情 著",
    publisher: "人民文学出版社",
    price: 36,
    originalPrice: 50,
    rating: 4.9,
    reviews: 2134,
    sold: 8760,
    image: "https://readdy.ai/api/search-image?query=Chinese%20friendship%20and%20gratitude%20book%20cover%2C%20warm%20and%20touching%20design%20with%20soft%20peach%20and%20gold%20colors%2C%20illustration%20of%20friends%20holding%20hands%20and%20laughing%20together%2C%20heartwarming%20friendship%20values%20book%2C%20gentle%20beautiful%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book024&orientation=portrait",
    tags: ["感恩友情", "珍惜友谊", "人际关系"],
    supplierName: "人民文学出版社",
    supplierVerified: true,
    description: "通过感人的友情故事，引导读者学会珍惜身边的朋友，感恩那些在人生路上陪伴自己的人。适合青少年和成年人阅读，是一本温暖心灵的感恩之书。",
    commissionRate: 17,
  },
  {
    id: "b025",
    title: "感恩节日·传递幸福",
    subtitle: "春节·中秋·重阳·感恩节的故事",
    category: "gratitude",
    categoryLabel: "感恩教育",
    author: "节日文化编委会",
    publisher: "中华书局",
    price: 45,
    originalPrice: 62,
    rating: 4.8,
    reviews: 1543,
    sold: 6780,
    image: "https://readdy.ai/api/search-image?query=Chinese%20traditional%20festival%20gratitude%20book%20cover%2C%20festive%20and%20warm%20design%20with%20red%20lanterns%20and%20golden%20moon%20illustrations%2C%20Spring%20Festival%20and%20Mid-Autumn%20Festival%20cultural%20elements%2C%20beautiful%20traditional%20Chinese%20holiday%20book%2C%20elegant%20calligraphy%20style%20on%20warm%20cream%20background&width=300&height=400&seq=book025&orientation=portrait",
    tags: ["节日感恩", "传统文化", "幸福传递"],
    supplierName: "中华书局",
    supplierVerified: true,
    description: "讲述春节、中秋、重阳、感恩节等传统节日背后的感恩故事，引导读者在节日中感恩父母、朋友和社会，让每一个节日都充满爱与温暖。",
    commissionRate: 18,
  },
  // ── 幸福开心 ×4 ──────────────────────────────────────────────
  {
    id: "b006",
    title: "幸福人生的100个秘密",
    subtitle: "开心生活·积极心态·赚钱技能",
    category: "happiness",
    categoryLabel: "幸福开心",
    author: "赵幸福 著",
    publisher: "中信出版集团",
    price: 56,
    originalPrice: 78,
    rating: 4.8,
    reviews: 3210,
    sold: 15600,
    image: "https://readdy.ai/api/search-image?query=Chinese%20happiness%20and%20positive%20life%20skills%20book%20cover%2C%20bright%20and%20cheerful%20design%20with%20warm%20yellow%20and%20orange%20colors%2C%20sunshine%20and%20smiling%20face%20illustration%2C%20motivational%20self-help%20book%2C%20clean%20modern%20design%20on%20white%20background&width=300&height=400&seq=book006&orientation=portrait",
    tags: ["幸福生活", "积极心态", "赚钱技能"],
    supplierName: "中信教育书局",
    supplierVerified: true,
    description: "汇集100个让生活更幸福的实用秘密，涵盖人际关系、财富积累、健康生活、积极心态等方面，帮助读者找到属于自己的幸福密码。",
    commissionRate: 14,
  },
  {
    id: "b026",
    title: "每天开心一点点",
    subtitle: "365个让你快乐的小习惯",
    category: "happiness",
    categoryLabel: "幸福开心",
    author: "快乐研究院 编",
    publisher: "湖南文艺出版社",
    price: 42,
    originalPrice: 58,
    rating: 4.9,
    reviews: 4321,
    sold: 22100,
    image: "https://readdy.ai/api/search-image?query=Chinese%20daily%20happiness%20habits%20book%20cover%2C%20bright%20and%20joyful%20design%20with%20sunshine%20yellow%20and%20coral%20colors%2C%20smiling%20sun%20and%20cheerful%20flowers%20illustration%2C%20positive%20psychology%20self-help%20book%2C%20energetic%20modern%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book026&orientation=portrait",
    tags: ["每日快乐", "幸福习惯", "积极心理"],
    supplierName: "湖南文艺出版社",
    supplierVerified: true,
    description: "365个让你每天都开心的小习惯，从早晨起床到晚上入睡，用简单易行的方法培养积极心态，让幸福成为一种生活方式。",
    commissionRate: 15,
  },
  {
    id: "b027",
    title: "赚钱技能大全·财富自由之路",
    subtitle: "副业·投资·创业·理财全攻略",
    category: "happiness",
    categoryLabel: "幸福开心",
    author: "财富导师团队",
    publisher: "中信出版集团",
    price: 68,
    originalPrice: 92,
    rating: 4.8,
    reviews: 5678,
    sold: 28900,
    image: "https://readdy.ai/api/search-image?query=Chinese%20wealth%20building%20and%20money%20skills%20book%20cover%2C%20prosperous%20design%20with%20gold%20coins%20and%20rising%20chart%20on%20rich%20amber%20background%2C%20financial%20freedom%20concept%20illustration%2C%20motivational%20wealth%20book%2C%20bold%20confident%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book027&orientation=portrait",
    tags: ["赚钱技能", "财富自由", "副业创业"],
    supplierName: "中信教育书局",
    supplierVerified: true,
    description: "全面讲解现代人必备的赚钱技能，涵盖副业选择、投资理财、创业方法、财富管理等方面，帮助读者实现财富增长，走向财务自由。",
    commissionRate: 16,
  },
  {
    id: "b028",
    title: "正能量·让生命更美好",
    subtitle: "心理健康·情绪管理·人生智慧",
    category: "happiness",
    categoryLabel: "幸福开心",
    author: "心理学博士 王阳",
    publisher: "北京联合出版公司",
    price: 52,
    originalPrice: 72,
    rating: 4.7,
    reviews: 3456,
    sold: 17800,
    image: "https://readdy.ai/api/search-image?query=Chinese%20positive%20energy%20and%20mental%20wellness%20book%20cover%2C%20uplifting%20design%20with%20soft%20green%20and%20golden%20sunrise%20colors%2C%20blooming%20flower%20and%20butterfly%20illustration%2C%20psychology%20self-improvement%20book%2C%20serene%20and%20inspiring%20typography%20on%20clean%20white%20background&width=300&height=400&seq=book028&orientation=portrait",
    tags: ["正能量", "心理健康", "情绪管理"],
    supplierName: "北京联合出版",
    supplierVerified: true,
    description: "从心理学角度解析如何保持正能量，系统讲解情绪管理、压力释放、人际关系处理等方法，帮助读者建立积极健康的心理状态，让生命更美好。",
    commissionRate: 14,
  },
  // ── 儿童成长 ×4 ──────────────────────────────────────────────
  {
    id: "b010",
    title: "小朋友的爱心故事书",
    subtitle: "培养爱心·关爱他人·快乐成长",
    category: "children",
    categoryLabel: "儿童成长",
    author: "彩虹童书编委会",
    publisher: "少年儿童出版社",
    price: 29,
    originalPrice: 42,
    rating: 5.0,
    reviews: 5678,
    sold: 32100,
    image: "https://readdy.ai/api/search-image?query=Chinese%20children%20love%20and%20kindness%20story%20book%20cover%2C%20colorful%20and%20joyful%20illustration%20with%20cute%20cartoon%20children%20helping%20each%20other%2C%20rainbow%20colors%2C%20warm%20and%20happy%20children%20book%20design%2C%20bright%20cheerful%20cover%20on%20white%20background&width=300&height=400&seq=book010&orientation=portrait",
    tags: ["爱心培养", "儿童故事", "快乐成长"],
    supplierName: "少儿教育出版社",
    supplierVerified: true,
    description: "精心创作的10个爱心故事，通过可爱的卡通插图和温暖的故事情节，引导小朋友学会关爱他人、帮助弱小，培养善良有爱的好品格。",
    commissionRate: 18,
  },
  {
    id: "b029",
    title: "小小科学家·探索奇妙世界",
    subtitle: "科学启蒙·动手实验·好奇心培养",
    category: "children",
    categoryLabel: "儿童成长",
    author: "科学启蒙编委会",
    publisher: "科学出版社",
    price: 58,
    originalPrice: 78,
    rating: 4.9,
    reviews: 3987,
    sold: 18900,
    image: "https://readdy.ai/api/search-image?query=Chinese%20children%20science%20exploration%20book%20cover%2C%20colorful%20and%20exciting%20design%20with%20cartoon%20scientist%20child%2C%20magnifying%20glass%20and%20colorful%20chemistry%20experiments%2C%20planets%20and%20stars%20background%2C%20fun%20educational%20children%20book%2C%20bright%20vibrant%20colors%20on%20white%20background&width=300&height=400&seq=book029&orientation=portrait",
    tags: ["科学启蒙", "动手实验", "好奇心"],
    supplierName: "科学出版社",
    supplierVerified: true,
    description: "专为3-10岁儿童设计的科学启蒙书，包含50个有趣的家庭小实验，用生动的插图和简单的语言解释科学原理，培养孩子的好奇心和探索精神。",
    commissionRate: 17,
  },
  {
    id: "b030",
    title: "儿童品格培养·勇敢与自信",
    subtitle: "克服恐惧·建立自信·勇于尝试",
    category: "children",
    categoryLabel: "儿童成长",
    author: "儿童心理专家 林博士",
    publisher: "接力出版社",
    price: 34,
    originalPrice: 48,
    rating: 4.9,
    reviews: 4567,
    sold: 24300,
    image: "https://readdy.ai/api/search-image?query=Chinese%20children%20character%20building%20book%20cover%2C%20empowering%20design%20with%20brave%20little%20lion%20and%20cheerful%20child%20illustration%2C%20warm%20orange%20and%20yellow%20colors%2C%20confidence%20building%20children%20book%2C%20encouraging%20and%20uplifting%20design%20on%20clean%20white%20background&width=300&height=400&seq=book030&orientation=portrait",
    tags: ["品格培养", "勇敢自信", "儿童成长"],
    supplierName: "接力出版社",
    supplierVerified: true,
    description: "通过12个关于勇敢和自信的故事，帮助孩子克服恐惧、建立自信、勇于尝试新事物。配合亲子互动练习，是培养孩子良好品格的优秀读物。",
    commissionRate: 18,
  },
  {
    id: "b035",
    title: "儿童国学启蒙·三字经与弟子规",
    subtitle: "传统文化·品德教育·诵读经典",
    category: "children",
    categoryLabel: "儿童成长",
    author: "国学教育研究院",
    publisher: "中华书局",
    price: 48,
    originalPrice: 65,
    rating: 4.9,
    reviews: 7654,
    sold: 38900,
    image: "https://readdy.ai/api/search-image?query=Chinese%20children%20traditional%20culture%20classics%20book%20cover%2C%20elegant%20design%20with%20red%20and%20gold%20colors%2C%20ancient%20Chinese%20scroll%20and%20calligraphy%20brush%20illustrations%2C%20traditional%20education%20book%20for%20kids%2C%20beautiful%20classical%20Chinese%20art%20style%20on%20cream%20background&width=300&height=400&seq=book035&orientation=portrait",
    tags: ["国学启蒙", "三字经", "品德教育"],
    supplierName: "中华书局",
    supplierVerified: true,
    description: "精心编排的儿童国学启蒙读本，收录三字经、弟子规、千字文等经典，配以精美插图和拼音注释，帮助孩子在诵读中感受传统文化魅力，培养良好品德。",
    commissionRate: 16,
  },
  // ── 节日礼物书 ×4 ──────────────────────────────────────────────
  {
    id: "b008",
    title: "春节礼物书礼盒套装",
    subtitle: "传统文化·节日祝福·精美礼盒",
    category: "gift",
    categoryLabel: "节日礼物书",
    author: "多位作者",
    publisher: "故宫出版社",
    price: 198,
    originalPrice: 268,
    rating: 4.9,
    reviews: 2345,
    sold: 7890,
    image: "https://readdy.ai/api/search-image?query=Chinese%20New%20Year%20gift%20book%20set%20in%20beautiful%20red%20and%20gold%20gift%20box%2C%20traditional%20Chinese%20cultural%20design%2C%20festive%20and%20elegant%20packaging%20with%20auspicious%20patterns%2C%20premium%20holiday%20gift%20books%2C%20luxurious%20presentation%20on%20white%20background&width=300&height=400&seq=book008&orientation=portrait",
    tags: ["节日礼物", "精美礼盒", "传统文化"],
    supplierName: "故宫文化出版",
    supplierVerified: true,
    description: "精选5册传统文化精品书籍，配以精美礼盒包装，融合中国传统节日文化，是春节、中秋、生日等节日送给家人朋友的最佳礼物。",
    commissionRate: 20,
  },
  {
    id: "b031",
    title: "中秋月饼与团圆故事",
    subtitle: "传统节日·家庭团圆·精美礼盒",
    category: "gift",
    categoryLabel: "节日礼物书",
    author: "传统文化研究院",
    publisher: "中华书局",
    price: 168,
    originalPrice: 228,
    rating: 4.9,
    reviews: 1876,
    sold: 6540,
    image: "https://readdy.ai/api/search-image?query=Chinese%20Mid-Autumn%20Festival%20gift%20book%20set%2C%20elegant%20packaging%20with%20jade%20green%20and%20gold%20moon%20design%2C%20traditional%20mooncake%20and%20lantern%20illustrations%2C%20premium%20holiday%20gift%20box%20with%20ribbon%2C%20luxurious%20cultural%20book%20gift%20set%20on%20white%20background&width=300&height=400&seq=book031&orientation=portrait",
    tags: ["中秋礼物", "团圆故事", "精美礼盒"],
    supplierName: "中华书局",
    supplierVerified: true,
    description: "中秋节专属礼物书礼盒，收录关于月亮、团圆、思念的经典故事和诗词，配以精美月饼图案礼盒包装，是中秋节送给家人朋友的最佳礼物。",
    commissionRate: 22,
  },
  {
    id: "b032",
    title: "生日快乐·成长纪念书",
    subtitle: "个性定制·成长记录·珍贵礼物",
    category: "gift",
    categoryLabel: "节日礼物书",
    author: "定制出版团队",
    publisher: "艺术家出版社",
    price: 128,
    originalPrice: 168,
    rating: 4.8,
    reviews: 2345,
    sold: 9870,
    image: "https://readdy.ai/api/search-image?query=Chinese%20birthday%20gift%20book%20cover%2C%20joyful%20celebration%20design%20with%20colorful%20balloons%20and%20confetti%2C%20golden%20birthday%20cake%20illustration%2C%20personalized%20memory%20book%20concept%2C%20festive%20and%20warm%20design%20with%20pink%20and%20gold%20colors%20on%20clean%20white%20background&width=300&height=400&seq=book032&orientation=portrait",
    tags: ["生日礼物", "成长纪念", "个性定制"],
    supplierName: "艺术家出版社",
    supplierVerified: true,
    description: "专为生日定制的成长纪念书，记录人生重要时刻，配以精美插图和励志寄语，是送给孩子、朋友、父母生日的最有意义的礼物，珍藏一生。",
    commissionRate: 20,
  },
  {
    id: "b036",
    title: "教师节感恩礼物书",
    subtitle: "师恩难忘·感谢老师·精美装帧",
    category: "gift",
    categoryLabel: "节日礼物书",
    author: "感恩教育编委会",
    publisher: "教育科学出版社",
    price: 88,
    originalPrice: 118,
    rating: 4.9,
    reviews: 3210,
    sold: 12400,
    image: "https://readdy.ai/api/search-image?query=Chinese%20Teachers%20Day%20gift%20book%20cover%2C%20warm%20and%20respectful%20design%20with%20soft%20golden%20and%20white%20colors%2C%20teacher%20and%20student%20illustration%2C%20apple%20and%20graduation%20cap%20symbols%2C%20heartfelt%20appreciation%20book%2C%20elegant%20premium%20design%20on%20clean%20white%20background&width=300&height=400&seq=book036&orientation=portrait",
    tags: ["教师节礼物", "感恩老师", "精美装帧"],
    supplierName: "教育科学出版社",
    supplierVerified: true,
    description: "教师节专属感恩礼物书，收录感人的师生故事和学生对老师的感谢信，配以精美装帧，是教师节送给恩师最真诚的礼物，表达对老师的感恩之情。",
    commissionRate: 19,
  },
];

export const supplierBookStats = {
  totalBooks: 847,
  totalSuppliers: 156,
  totalSold: 2340000,
  avgRating: 4.8,
};
